import Button from '@mui/joy/Button';
import {Link} from "react-router-dom";

import './styles/CallToAction.css'

const CallToAction = () => {
    return (
        <Link to='/join'>
            <Button sx={{backgroundColor: '#006494'}} className='call-to-action-button' href='/join'>
                <a className='call-to-action-link' href="/join">Plan a Visit!</a>
            </Button>
        </Link>
    );
}

export default CallToAction